import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment.staging';

@Injectable({
  providedIn: 'root'
})
export class OrderCreationService {
  private apiUrl = 'order_creation';
  private stockApiUrl = 'stocks';

  constructor(private apiService: ApiService, private http: HttpClient) { }

  getOrders(queryParams?: HttpParams): Observable<any> {
    return this.apiService.get(this.apiUrl, queryParams);
  }

  getOrder(id: any): Observable<any> {
    return this.apiService.get(`${this.apiUrl}/${id}`);
  }

  createOrder(data: any): Observable<any> {
    return this.apiService.post(this.apiUrl, data);
  }

  updateOrder(id: any, data: any): Observable<any> {
    return this.apiService.update(`${this.apiUrl}/${id}`, data);
  }

  deleteOrder(id: any): Observable<any> {
    return this.apiService.delete(`${this.apiUrl}/${id}`);
  }

  getGeneralProductCodeForProductDesign(queryParams?: HttpParams) {
    return this.apiService.get('completed-assembly-codes', queryParams);
  }

  getKalakarSuppliers(): Observable<any> {
    return this.apiService.get('users?suppliertype=kalakar,Karigar');
  }

  checkStockAvailability(itemCodes: string[], firmId: number): Observable<any> {
    let params = new HttpParams();
    params = params.append('firm_id', firmId.toString());
    itemCodes.forEach(code => {
      params = params.append('item_codes[]', code);
    });
    return this.apiService.get(this.stockApiUrl, params);
  }
  getOrderAssignHistory(orderId: number): Observable<any> {
    return this.apiService.get(`${this.apiUrl}/${orderId}/assign-history`);
  }


  handOverOrder(orderId: number) {
    return this.apiService.post(`order-handover/${orderId}`, {});
  }

  getIssuedRawMaterials(firmId: number) {
    let params = new HttpParams();
    params = params.append('ordc_firm_id', firmId.toString());
    return this.apiService.get('issued-raw-materials', params);
  }

  requestRawMaterialReturn(orderId: number) {
    return this.apiService.post(
      `order_creations/${orderId}/request-return`,
      {}
    );
  }

  approveRawMaterialReturn(orderId: number) {
    return this.apiService.post(
      `order_creations/${orderId}/approve-return`,
      {}
    );
  }

  getRawMaterialReturnCount() {
    return this.apiService.get('raw-material-return-count');
  }

  getReturnedRawMaterials(firmId: number) {
    let params = new HttpParams()
      .set('ordc_firm_id', firmId.toString());

    return this.apiService.get('raw-materials/returned', params);
  }

  payLabourAmount(orderId: number, amount: number) {
    return this.apiService.post(
      `orders/${orderId}/labour-payment`,
      { paid_amt: amount }
    );
  }

  getKalakarTransactions(params?: HttpParams): Observable<any> {
    return this.apiService.get('orders-transactions', params);
  }

}
